import type { LayoutType } from '@/api/types'
import type {
  CurrentUser,
  PermissionAdminLevel,
  PermissionLevel,
} from '@/api/User/types'
import type {
  AdminPermissionType,
  AuthUser,
  Role,
} from '@/hooks/useGetCurrentUser/types'
import {
  hasAdminPermission,
  hasAnyInitiativeOrBelowPermission,
  hasPermission,
  someRole,
} from '@/hooks/useGetCurrentUser/utils'
import { clearPersistedBusinessFilters } from '@/utils/businessFilterStorage'

export const hasUserLocale = () => {
  const userEnrichement = localStorage.getItem('user-enrichement')
  return !!userEnrichement
}

export const enrichmentUserWithMethods = (data: CurrentUser): AuthUser => ({
  ...data,
  hasAdminPermission: (
    type: AdminPermissionType,
    level: PermissionAdminLevel
  ) => hasAdminPermission(data, type, level),
  hasPermission: (
    level: PermissionLevel,
    initiativeId?: number,
    featureId?: number,
    type?: LayoutType | 'any'
  ) => hasPermission(data, level, initiativeId, featureId, type),
  hasAnyInitiativeOrBelowPermission: (level: PermissionLevel) =>
    hasAnyInitiativeOrBelowPermission(data, level),
  someRole: (roles: Role[]) => someRole(data, roles),
})

export const getCurrentUser = () => {
  const userEnrichement = localStorage.getItem('user-enrichement')

  if (!userEnrichement) {
    return
  }

  const currentUser = JSON.parse(userEnrichement) as CurrentUser
  return enrichmentUserWithMethods(currentUser)
}

export const saveCurrentUser = (user: CurrentUser) => {
  localStorage.setItem('user-enrichement', JSON.stringify(user))
}

export const clearCurrentUser = () => {
  localStorage.removeItem('user-enrichement')
}

export const logout = () => {
  clearCurrentUser()
  clearPersistedBusinessFilters()
}
